<template>
    <div id="main">
        <div class="page page-container">
            <div class="propriedade vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("propriedade") }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()"
                            >
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("cadastros")
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{ $route.params.id ? propriedade.idpropriedadeerp : $t("novo") }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToPage"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="
                                ((!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)) && !propriedadeIntegracao
                            "
                            class="save-btn"
                            type="button"
                            @click="save()"
                            :disabled="isSaving || saved"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>

                <ul class="nav nav-tabs">
                    <li
                        v-for="(aba, i) in abas"
                        :class="{ active: abaSelecionada == i }"
                        :key="i"
                        @click="abaSelecionada = i"
                    >
                        <a data-toggle="tab" :href="`#${aba}`">{{
                            $t(aba)
                        }}</a>
                    </li>
                </ul>

                <!-- ABA GERAL -->
                <div v-show="abaSelecionada == 0">
                    <!-- FORMULÁRIO -->
                    <div class="columns pt-4">
                        <div class="column is-2">
                            <v-input
                                :id="'codigo'"
                                ref="idpropriedadeerpInput"
                                v-model="propriedade.idpropriedadeerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div
                            class="column"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.NOME && !detalhe.NOME.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(1)"
                                ref="nomeInput"
                                v-model="propriedade.nome"
                                :title="
                                    detalhe.NOME
                                        ? detalhe.NOME.label || $t('nome')
                                        : $t('nome')
                                "
                                :maxlength="
                                    detalhe.NOME
                                        ? detalhe.NOME.maxlength || 255
                                        : 255
                                "
                                :invalid="
                                    checkInvalid('NOME', propriedade.nome)
                                "
                                :disabled="
                                    isSaving ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                disableMLtitle
                                uppercase
                                required
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div
                            class="column is-full is-flex"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.ENDERECO && !detalhe.ENDERECO.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(2)"
                                class="is-100"
                                ref="enderecoInput"
                                v-model="propriedade.endereco"
                                :title="
                                    detalhe.ENDERECO
                                        ? detalhe.ENDERECO.label ||
                                          $t('endereco')
                                        : $t('endereco')
                                "
                                :maxlength="
                                    detalhe.ENDERECO
                                        ? detalhe.ENDERECO.maxlength || 255
                                        : 255
                                "
                                :invalid="
                                    checkInvalid(
                                        'ENDERECO',
                                        propriedade.endereco
                                    )
                                "
                                :disabled="
                                    isSaving ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                disableMLtitle
                                required
                            />
                                <b-button
                                    v-if="
                                        detalhe.length == 0 ||
                                        (detalhe.GEOLOCALIZACAO &&
                                            !detalhe.GEOLOCALIZACAO.oculta)
                                    "
                                    :id="generateId(3)"
                                    @click="
                                        geocodeAddress(propriedade.endereco)
                                    "
                                    type="is-primary"
                                    icon-left="target"
                                    :loading="geocoderLoading"
                                    :disabled="isSaving || saved"
                                    v-tippy 
                                    :title="$t('msg-tooltip-pesquisa-geocoder')"
                                />
                            <div
                                class="icon-help drop is-flex is-flex-centered"
                            >
                                <b-icon
                                    type="is-primary"
                                    icon="help-circle"
                                    v-tippy 
                                    :title="$t(
                                        'msg-tooltip-endereco-propriedade'
                                    )"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="columns">
                        <div
                            class="column"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.CNPJCPF && !detalhe.CNPJCPF.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(4)"
                                :hideInfo="hide.hideInfo"
                                :infoIsHidden="hide.infoIsHidden"
                                v-model="propriedade.cnpjcpf"
                                :title="
                                    detalhe.CNPJCPF
                                        ? detalhe.CNPJCPF.label ||
                                          $t('cnpj-cpf')
                                        : $t('cnpj-cpf')
                                "
                                :msg="invalidCNPJMsg"
                                :invalid="invalidCNPJ"
                                :onBlurFunction="validateCNPJInner"
                                ref="cnpjCpfInput"
                                :disabled="
                                    isSaving ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                disableMLtitle
                                :useMask="true"
                                required
                                :vMask="[
                                    '###.###.###-##',
                                    '##.###.###/####-##',
                                ]"
                            />
                        </div>
                        <div
                            class="column"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.IERG && !detalhe.IERG.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(5)"
                                ref="rgIeInput"
                                v-model="propriedade.ierg"
                                :title="
                                    detalhe.IERG
                                        ? detalhe.IERG.label || $t('rg-ie')
                                        : $t('rg-ie')
                                "
                                :invalid="
                                    checkInvalid('IERG', propriedade.ierg)
                                "
                                :maxlength="
                                    detalhe.IERG
                                        ? detalhe.IERG.maxlength || 20
                                        : 20
                                "
                                :disabled="
                                    isSaving ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                :validchars="
                                    detalhe.IERG
                                        ? detalhe.IERG.validchars || null
                                        : null
                                "
                                disableMLtitle
                                required
                            />
                        </div>
                        <div class="column">
                            <vss-select
                                :id="generateId(6)"
                                ref="clienteSelect"
                                label="rsocial"
                                v-model="propriedade.cliente"
                                title="cliente"
                                :options="clientes"
                                :loading="clientesLoading"
                                :invalid="!propriedade.cliente"
                                :disabled="
                                    isSaving ||
                                    saved ||
                                    fixedClient ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                @search="carregarClientes"
                                searchable
                                required
                            />
                        </div>
                    </div>
                    <div class="columns">
                        <div class="column">
                            <v-input

                                :title="`${$t('area')} ${
                                    propriedade.unidadeMedida
                                        ? `(${propriedade.unidadeMedida.sigla})`
                                        : ''
                                }`"
                                :value="
                                    getDecimal(
                                        getAreaTotal(propriedade.areas),
                                        2
                                    )
                                "
                                disabled
                                disableMLtitle
                                tooltipLabel="soma-das-areas"
                                tooltipSize="is-small"
                            />
                        </div>
                        <div
                            class="column"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.UNIDADEMEDIDA &&
                                    !detalhe.UNIDADEMEDIDA.oculta)
                            "
                        >
                            <vss-select
                                :id="generateId(7)"
                                ref="unMedidaSelect"
                                label="descricao"
                                v-model="propriedade.unidadeMedida"
                                :title="
                                    detalhe.UNIDADEMEDIDA
                                        ? detalhe.UNIDADEMEDIDA.label ||
                                          $t('unidade-medida')
                                        : $t('unidade-medida')
                                "
                                :invalid="
                                    checkInvalid(
                                        'UNIDADEMEDIDA',
                                        propriedade.unidadeMedida
                                    )
                                "
                                :options="unidades"
                                :loading="unidadesLoading"
                                :disabled="
                                    isSaving ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                @search="carregarUnidades"
                                searchable
                                disableMLtitle
                                required
                            />
                        </div>
                        <div
                            class="column"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.GEOLOCALIZACAO &&
                                    !detalhe.GEOLOCALIZACAO.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(8)"
                                :value="getDecimal(propriedade.latitude, 6)"
                                ref="latInput"
                                title="latitude"
                                disabled
                            />
                        </div>
                        <div
                            class="column"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.GEOLOCALIZACAO &&
                                    !detalhe.GEOLOCALIZACAO.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(9)"
                                :value="getDecimal(propriedade.longitude, 6)"
                                ref="lngInput"
                                title="longitude"
                                disabled
                            />
                        </div>
                    </div>

                    <div
                        class="map-area vertical-flow mt-4"
                        v-if="
                            detalhe.length == 0 ||
                            (detalhe.GEOLOCALIZACAO &&
                                !detalhe.GEOLOCALIZACAO.oculta)
                        "
                    >
                        <div class="mt-4 mb-2 has-text-centered">
                            <b-button
                                :id="generateId(10)"
                                outlined
                                icon-left="eye-off-outline"
                                type="is-danger"
                                v-if="!hide.mapsIsHidden"
                                @click="mapsIsHidden()"
                            >
                                {{ $t("esconder-localizacao") }}
                            </b-button>
                            <b-button
                                :id="generateId(11)"
                                outlined
                                icon-left="eye-outline"
                                type="is-success"
                                v-if="hide.mapsIsHidden"
                                @click="mapsIsHidden()"
                            >
                                {{ $t("mostrar-localizacao") }}
                            </b-button>
                            <b-image
                                v-show="hide.mapsIsHidden"
                                :src="require('@/assets/img/maps.png')"
                                alt="Mapa"
                                class="hide-location mt-2"
                            />
                        </div>
                        <div class="location" v-show="!hide.mapsIsHidden">
                            <gmap-map
                                ref="map"
                                class="map-el"
                                :center="center"
                                :zoom="zoomLevel"
                                :options="mapOptions"
                                @click="updatePosition"
                            >
                                <gmap-marker
                                    :visible="
                                        propriedade.latitude != 0 ||
                                        propriedade.longitude != 0
                                    "
                                    :position="getPosicao()"
                                    :icon="pinIcon"
                                    @drag="updatePosition"
                                    :draggable="!(isSaving || saved)"
                                />
                                <gmap-info-window
                                    ref="infoWindow"
                                    :position="infoWindow.position"
                                    :opened="infoWindow.open"
                                    :options="infoWindow.options"
                                    @closeclick="infoWindow.open = false"
                                >
                                    <div class="info-window">
                                        <div class="info-window-message">
                                            <div class="icon">
                                                <svg class="fail">
                                                    <use
                                                        :xlink:href="
                                                            require('@/assets/img/icons/location-off.svg') +
                                                            '#layer'
                                                        "
                                                    ></use>
                                                </svg>
                                            </div>
                                            <p class="info-window-nome">
                                                {{
                                                    $t(
                                                        "msg-sem-geolocalizacao"
                                                    )
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                </gmap-info-window>
                            </gmap-map>
                        </div>
                    </div>
                </div>

                <!-- ABA TALHÕES -->
                <div class="registry-wrapper" v-show="abaSelecionada == 1">
                    <div
                        class="columns pt-4"
                        v-if="
                            (!isUpdate && permissao.create) ||
                            (isUpdate && permissao.update)
                        "
                    >
                        <div
                            class="column"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.TALHAO_DESCRICAO &&
                                    !detalhe.TALHAO_DESCRICAO.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(12)"
                                ref="descricaoInput"
                                class="is-grow-1"
                                v-model="talhao.descricao"
                                :title="
                                    detalhe.TALHAO_DESCRICAO
                                        ? detalhe.TALHAO_DESCRICAO.label ||
                                          $t('descricao')
                                        : $t('descricao')
                                "
                                :invalid="
                                    checkInvalid(
                                        'TALHAO_DESCRICAO',
                                        talhao.descricao
                                    )
                                "
                                :disabled="
                                    isSaving ||
                                    isSavingTalhao ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                :maxlength="
                                    detalhe.TALHAO_DESCRICAO
                                        ? detalhe.TALHAO_DESCRICAO.maxlength ||
                                          255
                                        : 255
                                "
                                disableMLtitle
                                required
                            />
                        </div>
                        <div class="column is-narrow is-hidden-mobile">
                            <button
                                :id="generateId(13)"
                                class="btn delete-btn in-form"
                                @click="cancelEditRow"
                                :disabled="isSaving || isSavingTalhao || saved"
                            >
                                {{ $t("cancelar") }}
                            </button>
                            <button
                                :id="generateId(14)"
                                class="btn save-btn in-form ml-2"
                                @click="saveTalhao"
                                :disabled="isSaving || isSavingTalhao || saved"
                            >
                                {{
                                    currentEditTalhao > -1
                                        ? $t("confirmar")
                                        : $t("adicionar")
                                }}
                            </button>
                        </div>
                    </div>
                    <div
                        class="columns"
                        v-if="
                            (!isUpdate && permissao.create) ||
                            (isUpdate && permissao.update)
                        "
                    >
                        <div
                            class="column is-flex is-5"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.TALHAO_AREA &&
                                    !detalhe.TALHAO_AREA.oculta)
                            "
                        >
                            <vss-select
                                :id="generateId(15)"
                                class="vss-grow"
                                ref="areaSelect"
                                v-model="talhao.areadesc"
                                label="descricao"
                                :title="
                                    detalhe.TALHAO_AREA
                                        ? detalhe.TALHAO_AREA.label ||
                                          $t('area')
                                        : $t('area')
                                "
                                :invalid="
                                    checkInvalid('TALHAO_AREA', talhao.areadesc)
                                "
                                :options="filteredAreas"
                                :disabled="
                                    isSaving ||
                                    isSavingTalhao ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                @search="carregarAreas"
                                searchable
                                disableMLtitle
                                required
                            />
                            <div
                                class="
                                    buttons
                                    has-addons
                                    is-flex-nowrap
                                    ml-2
                                    drop
                                "
                            >
                                <b-button
                                    :id="generateId(16)"
                                    type="is-light"
                                    icon-left="pencil"
                                    :title="$t('editar-area')"
                                    @click="editArea"
                                    :disabled="
                                        !talhao.areadesc ||
                                        isSaving ||
                                        isSavingTalhao ||
                                        saved
                                    "
                                />
                                <b-button
                                    type="is-primary"
                                    icon-left="plus"
                                    :title="$t('nova-area')"
                                    @click="newArea"
                                    :disabled="
                                        isSaving || isSavingTalhao || saved
                                    "
                                />
                            </div>
                        </div>
                        <div
                            class="column is-3"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.TALHAO_AREATALHAO &&
                                    !detalhe.TALHAO_AREATALHAO.oculta)
                            "
                        >
                            <v-input
                                :id="generateId(17)"
                                ref="areaInput"
                                type="tel"
                                v-model="talhao.area"
                                :min="0"
                                :maxlength="15"
                                :title="`${
                                    detalhe.TALHAO_AREATALHAO
                                        ? detalhe.TALHAO_AREATALHAO.label ||
                                          $t('area-total')
                                        : $t('area-total')
                                } ${
                                    propriedade.unidadeMedida
                                        ? `(${propriedade.unidadeMedida.sigla})`
                                        : ''
                                }`"
                                :invalid="
                                    checkInvalid(
                                        'TALHAO_AREATALHAO',
                                        talhao.area
                                    ) || parseFloat(talhao.area) < 0
                                "
                                :disabled="
                                    isSaving ||
                                    isSavingTalhao ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                :msg="
                                    parseFloat(talhao.area) < 0
                                        ? 'msg-qtd-zero-invalid'
                                        : 'msg-campo-obrigatorio'
                                "
                                validchars="0123456789.,"
                                disableMLtitle
                                required
                            />
                        </div>
                        <div
                            class="column is-4"
                            v-if="
                                detalhe.length == 0 ||
                                (detalhe.TALHAO_TIPOTALHAO &&
                                    !detalhe.TALHAO_TIPOTALHAO.oculta)
                            "
                        >
                            <vss-select
                                :id="generateId(18)"
                                class="is-100"
                                ref="tipoInput"
                                v-model="talhao.tipocadastrotalhao"
                                label="descricao"
                                :title="
                                    detalhe.TALHAO_TIPOTALHAO
                                        ? detalhe.TALHAO_TIPOTALHAO.label ||
                                          $t('tipo')
                                        : $t('tipo')
                                "
                                :invalid="
                                    checkInvalid(
                                        'TALHAO_TIPOTALHAO',
                                        talhao.tipocadastrotalhao
                                    )
                                "
                                :options="tiposCadastroTalhao"
                                :loading="tiposCadastroTalhaoLoading"
                                :disabled="
                                    isSaving ||
                                    isSavingTalhao ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                                @search="carregarTipos"
                                searchable
                                disableMLtitle
                                required
                            />
                        </div>
                    </div>
                    <!-- BOTÕES DO TALHÃO PARA APARECEREM SOMENTE EM VIEWPOINT ESTREITO (MOBILE) -->
                    <div class="columns is-hidden-tablet">
                        <div class="column is-full">
                            <button
                                :id="generateId(19)"
                                class="btn delete-btn is-100"
                                @click="cancelEditRow"
                                :disabled="
                                    isSaving ||
                                    isSavingTalhao ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                            >
                                {{ $t("cancelar") }}
                            </button>
                            <button
                                :id="generateId(20)"
                                class="btn save-btn is-100 mt-4"
                                @click="saveTalhao"
                                :disabled="
                                    isSaving ||
                                    isSavingTalhao ||
                                    saved ||
                                    (isUpdate && !permissao.update) ||
                                    (!isUpdate && !permissao.create)
                                "
                            >
                                {{
                                    currentEditTalhao > -1
                                        ? $t("confirmar")
                                        : $t("adicionar")
                                }}
                            </button>
                        </div>
                    </div>
                    <hr class="mt-6" />
                    <div
                        class="
                            area-tables
                            is-grow-1 is-flex is-flex-column is-relative
                        "
                    >
                        <!-- FILTROS TALHÕES -->
                        <div class="columns is-multiline">
                            <div class="column">
                                <search-bar
                                    :onSearch="debouncedOnSearch"
                                />
                            </div>

                            <!-- SITUACAO -->

                            <div class="situacao-select column is-one-quarter">
                                <label
                                    for="situacao"
                                    v-text="$t('situacao')"
                                />
                                <v-select
                                    :id="generateId(21)"
                                    title="situacao"
                                    ref="situacaoInput"
                                    class="is-100"
                                    label="situacao"
                                    :selectHeight="40"
                                    :options="situacoes"
                                    @input="updateSituacao"
                                    v-model="situacao"
                                >
                                    <template slot="option" slot-scope="option">
                                        {{ $t(option.label) }}
                                    </template>
                                    <template
                                        slot="selected-option"
                                        slot-scope="option"
                                    >
                                        {{ $t(option.label) }}
                                    </template>
                                    <template slot="no-options">{{
                                        $t("sem-resultados")
                                    }}</template>
                                </v-select>
                            </div>
                        </div>

                        <container-loader
                            v-if="isLoadingTalhoes && !$store.getters.isLoading"
                        />
                        <empty-table-message
                            msg="msg-no-talhoes"
                            v-if="
                                propriedade.areas && !propriedade.areas.length
                            "
                        />
                        <b-table
                            v-else
                            ref="areaTalhaoTable"
                            class="data-table mt-2 uppercase"
                            :data="propriedade.areas"
                            :row-class="
                                (row, index) =>
                                    index === currentEditArea
                                        ? 'is-editing'
                                        : ''
                            "
                            detailed
                            custom-detail-row
                            show-detail-icon
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                class="td-center"
                                :key="i"
                                :visible="
                                    f.campo
                                        ? detalhe.length == 0 ||
                                          (detalhe[f.campo] &&
                                              !detalhe[f.campo].oculta)
                                        : true
                                "
                                :field="f.key"
                                :label="f.label ? $t(f.label) : ''"
                                :sortable="f.sortable"
                                :centered="f.centered"
                                :numeric="f.numeric"
                                :width="f.width"
                                v-slot="props"
                            >
                                <template slot="header">
                                    <span v-if="f.key == 'descricao'">
                                        {{
                                            detalhe.TALHAO_DESCRICAO
                                                ? detalhe.TALHAO_DESCRICAO
                                                      .label ||
                                                  $t("talhoes-por-area")
                                                : $t("talhoes-por-area")
                                        }}
                                    </span>
                                    <span v-if="f.key == 'areadesc'">
                                        {{
                                            detalhe.TALHAO_AREA
                                                ? detalhe.TALHAO_AREA.label ||
                                                  $t("area")
                                                : $t("area")
                                        }}
                                    </span>
                                    <span v-if="f.key == 'tipocadastro'">
                                        {{
                                            detalhe.TALHAO_TIPOTALHAO
                                                ? detalhe.TALHAO_TIPOTALHAO
                                                      .label || $t("tipo")
                                                : $t("tipo")
                                        }}
                                    </span>
                                    <span v-else-if="f.key == 'area'">
                                        {{
                                            detalhe.TALHAO_AREATALHAO
                                                ? detalhe.TALHAO_AREATALHAO
                                                      .label ||
                                                  $t("area-total")
                                                : $t("area-total")
                                        }}
                                        {{
                                            propriedade.unidadeMedida
                                                ? `(${propriedade.unidadeMedida.sigla})`
                                                : ""
                                        }}
                                    </span>
                                </template>

                                <div v-if="f.key == 'descricao'">
                                    <b>{{ props.row[f.key] }}</b>
                                </div>
                                <div v-else-if="f.key == 'area'">
                                    <b>{{
                                        getDecimal(
                                            props.row.talhoes.reduce(
                                                (a, e) => a + (e.area || 0),
                                                0
                                            )
                                        )
                                    }}</b>
                                </div>
                            </b-table-column>

                            <template slot="detail" slot-scope="props">
                                <tr
                                    v-for="(talhao, idx) in props.row.talhoes"
                                    :key="talhao.descricao"
                                    :class="{
                                        'is-editing':
                                            idx === currentEditTalhao &&
                                            props.index === currentEditArea,
                                    }"
                                >
                                    <td></td>
                                    <td
                                        v-for="(c, i) in fields"
                                        :key="i"
                                        v-show="
                                            c.campo
                                                ? detalhe.length == 0 ||
                                                  (detalhe[c.campo] &&
                                                      !detalhe[c.campo].oculta)
                                                : true
                                        "
                                        class="td-center"
                                        :class="{
                                            'has-text-right': c.key == 'area',
                                            'has-text-centered':
                                                c.key == 'excluir',
                                        }"
                                    >
                                        <span
                                            v-if="c.key == 'tipocadastrotalhao'"
                                        >
                                            {{
                                                talhao.tipocadastrotalhao
                                                    .descricao
                                            }}
                                        </span>
                                        <span v-else-if="c.key == 'area'">
                                            {{ getDecimal(talhao.area, 2) }}
                                        </span>
                                        <div v-else-if="c.key == 'excluir'">
                                            <b-button
                                                type="is-light"
                                                icon-right="pencil"
                                                @click="
                                                    editRow(
                                                        talhao,
                                                        props.index,
                                                        idx
                                                    )
                                                "
                                                :disabled="
                                                    isSaving ||
                                                    saved ||
                                                    (idx == currentEditTalhao &&
                                                        props.index ==
                                                            currentEditArea)
                                                "
                                            />
                                            <b-button
                                                v-if="talhao.situacao"
                                                type="is-danger"
                                                icon-right="delete"
                                                @click="promptForDelete(talhao)"
                                            />

                                            <b-button
                                                v-else
                                                class="ml-1"
                                                type="is-success"
                                                icon-right="check"
                                                @click="
                                                    promptForCompletion(
                                                        talhao
                                                    )
                                                "
                                                v-tippy 
                                                :title="$t('reativar-talhao')"
                                            />
                                        </div>
                                        <span v-else>
                                            {{ talhao[c.key] }}
                                        </span>
                                    </td>
                                </tr>
                            </template>
                        </b-table>
                    </div>
                </div>

                <!-- MODAL EDIÇÃO ÁREA -->
                <b-modal :active="openModalArea" @close="closeArea">
                    <div class="modal-card modal-default m-edit">
                        <section class="modal-card-body">
                            <h1 class="title title-modal">
                                {{
                                    areaEditIdx > -1
                                        ? `${$t("editar-area")}:`
                                        : $t("nova-area")
                                }}
                                {{ areaEditIdx > -1 ? titulo : "" }}
                            </h1>
                            <div class="columns">
                                <div class="column is-full is-flex">
                                    <v-input
                                        :id="generateId(22)"
                                        class="is-100"
                                        v-model="area.descricao"
                                        title="descricao"
                                        :limit="255"
                                        :invalid="!area.descricao"
                                        :disabled="savingArea"
                                    />

                                    <button
                                        :id="generateId(23)"
                                        class="btn save-btn in-form ml-4"
                                        @click="saveArea"
                                        :disabled="savingArea"
                                    >
                                        {{ $t("salvar") }}
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import AreaService from "@/services/agro/AreaService";
import TalhaoService from "@/services/agro/TalhaoService";
import PropriedadeService from "@/services/agro/PropriedadeService";
import VendasClienteService from "@/services/VendasClienteService";
import UnidadeMedidaAreaService from "@/services/UnidadeMedidaAreaService";
import TipoCadastroTalhaoService from "@/services/TipoCadastroTalhaoService";
import { TheMask } from "vue-the-mask";
import PropriedadeValidation from "@/services/validations/PropriedadeValidation";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import { mapState } from "vuex";

/* @67517 */
export default {
    components: {
        ContainerLoader,
        TheMask,
    },
    data() {
        return {
            propriedadeIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("PROPRIEDADE"),
            id: this.$route.params.id,
            service: new PropriedadeService(this.$http, this.$router),
            talhaoService: new TalhaoService(this.$http, this.$router),
            venClienteService: new VendasClienteService(
                this.$http,
                this.$router
            ),
            unidadeAreaService: new UnidadeMedidaAreaService(
                this.$http,
                this.$router
            ),
            tipoService: new TipoCadastroTalhaoService(
                this.$http,
                this.$router
            ),
            areaService: new AreaService(this.$http, this.$router),
            validation: new PropriedadeValidation(
                this.$root.msgs,
                this.getModulo("PROPRIEDADE")
            ),
            geocoder: null,
            geocoderLoading: false,
            isSaving: false,
            isSavingTalhao: false,
            saved: false,
            abas: ["geral", "talhoes"],
            abaSelecionada: 0,
            propriedade: {
                nome: "",
                idpropriedadeerp: "",
                latitude: 0,
                longitude: 0,
                unidadeMedida: null,
                areas: [
                    /*  No PDA, ao criar uma propriedade, é criado por default uma área padrão "ÁREA 1".

                        Mesmo que o usuário não esteja usando área, ou seja, somente propriedade e talhões,
                        todos os talhões terão que estar dentro de uma área, no caso, esta.

                        Replicando o comportamento aqui. Caso a área seja carregada do servidor, este objeto
                        será sobrescrito. */
                    { descricao: "AREA 1", talhoes: [] },
                ],
                cnpjcpf: "",
                cliente: null,
            },
            filteredAreas: [],
            detalhe: {}, // guarda os MODULOPDADETALHE
            clientes: [],
            clientesLoading: false,
            unidades: [],
            unidadesLoading: false,
            /* Referente as configs do mapa */
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
            },
            center: { lat: -15, lng: -50 },
            zoomLevel: 8,
            mapOptions: {
                mapTypeControl: false,
                streetViewControl: false,
                scaleControl: false,
                zoomControl: false,
                fullscreenControl: true,
                fullscreenControlOptions: {
                    position: 7, //google.maps.ControlPosition.RIGHT_TOP
                },
            },
            pinIcon: {
                path: "M10.0812 0.00417221V0C10.0537 0 10.0269 0.00166887 10 0.00166887C9.97313 0.00166887 9.94626 0 9.91877 0V0.00417221C4.42628 0.0930404 0 4.64555 0 10.2528C0 17.8089 8.72292 24.9809 10 26C11.2773 24.9811 20 17.8087 20 10.2528C20 4.64555 15.5739 0.0930404 10.0812 0.00417221ZM10.0812 14.663C7.20729 14.663 4.87795 12.2945 4.87795 9.37205C4.87795 6.44879 7.20729 4.0798 10.0812 4.0798C12.9552 4.0798 15.2847 6.44879 15.2847 9.37205C15.2847 12.2945 12.9552 14.663 10.0812 14.663Z",
                fillColor: this.$store.state.partnerSystemHasLayout.primary_color,
                scale: 1,
                fillOpacity: 1,
                strokeWeight: 0,
                anchor: { x: 10, y: 25 },
            },
            defaultPos: {
                lat: -24.955954,
                lng: -53.455791,
            },
            /* Referente ao cadastro de talhão */
            talhoes: [],
            talhao: {},
            currentEditArea: -1, // índice no array da área que contem um talhão que está sendo editado
            currentEditTalhao: -1, // índice no array do talhão que está sendo editado
            tiposCadastroTalhao: [],
            tiposCadastroTalhaoLoading: false,
            invalidCNPJ: true,
            invalidCNPJMsg: "msg-campo-obrigatorio",
            // areas: [],
            fields: [
                {
                    key: "descricao",
                    label: "talhoes-por-area",
                    campo: "TALHAO_DESCRICAO",
                    sortable: false,
                },
                {
                    key: "tipocadastrotalhao",
                    label: "tipo",
                    campo: "TALHAO_TIPOTALHAO",
                    sortable: false,
                    width: "25%",
                },
                {
                    key: "area",
                    label: "area-total",
                    campo: "TALHAO_AREATALHAO",
                    sortable: false,
                    width: 200,
                    numeric: true,
                },
                {
                    key: "excluir",
                    label: "",
                    sortable: false,
                    width: 140,
                    centered: true,
                },
            ],
            column: "",
            order: "",
            isLoadingTalhoes: false,
            totalRows: 0,
            currentPage: 1,
            perPage: 20,
            openModalArea: false,
            titulo: "",
            queryFilter: "",
            area: {},
            areaEditIdx: -1,
            savingArea: false,
            loadingArea: false,
            situacoes: [
                { label: "todos", id: 2 },
                { label: "ativo", id: 1 },
                { label: "inativo", id: 0 },
            ],
            situacao: { label: "todos", id: 2 },
            fixedClient: false,
            newTalhoes: [],
            isUpdate: false,
            isLoading: true,

            isVenda: this.$route.meta.contexto == "vendas",
        };
    },
    created() {
        if (this.$route.params.id) {
            this.isUpdate = true;
        }
        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-cadastros",
            "agro-propriedade"
        );
        if (
            (!this.isUpdate && !this.permissao.create) || 
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-propriedade" },
            });
        } else {
            /* Procura carregar o MODULOPDA de PROPRIEDADE antes que a página esteja montada. */
            this.getModuloPropriedade();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    computed: {
        ...mapState(["hide"]),
        propriedadeNome() {
            if (this.propriedade.nome) {
                return `: ${this.propriedade.nome}`;
            }
            return "";
        },
    },
    mounted() {

        /*  Necessário pois no momento do mounted a API do gmaps (que contém o objeto google
            para poder definir e criar novos tipos e instanciar a ferramenta, como o geocoder
            abaixo) não está carregada.

            Então quando a API estiver carregada, carrega-se os dados, dentre outras coisas
            dependentes e evita o erro "google is not defined".

            Referência: https://github.com/xkjyeah/vue-google-maps/wiki/vue-google-maps-FAQ
        */
        this.$gmapApiPromiseLazy()
            .then((_) => {
                console.log("API Gmaps carregada.");
                this.geocoder = new google.maps.Geocoder("br");
            })
            .finally((_) => {
                if (this.id) {
                    this.carregarDados(this.id, true);
                } else {
                    this.loadCurrentPosition();
                }
            });
    },
    methods: {
        generateId(numberId) {
            return this.$route.name+'-geral-'+numberId;
        },
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        mapsIsHidden() {
            this.$store.dispatch("mapsIsHidden", {
                mapsIsHidden: !this.hide.mapsIsHidden,
            });
        },
        navigateTab(name) {
            let idx = this.abas.findIndex((e) => e == name);

            if (idx > -1) {
                this.abaSelecionada = idx;
            }
        },
        carregarDados(id, navigateToTab = false) {

            this.isLoading = true;
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.propriedade = body.content;

                        /*  Remover ponto e traço ser vier do banco assim
                            Pois no banco pode estar tanto com ou sem, então prefere-se retirar
                            e padronizar novamente. */
                        this.propriedade.cnpjcpf =
                            this.propriedade.cnpjcpf.replace(/[\.\/-]/g, "");

                        /* Define o nível de zoom já que a localização vai estar cadastrada */
                        this.zoomLevel = 12;
                        this.center.lat = this.propriedade.latitude;
                        this.center.lng = this.propriedade.longitude;
                        this.filteredAreas = this.propriedade.areas;

                        this.infoWindow.open = !(
                            this.propriedade.latitude != 0 ||
                            this.propriedade.longitude != 0
                        );
                    }
                })
                .catch((e) => {
                    console.error("Erro ao carregar propriedade.", e);
                    this.$root.showMessage(
                        "error",
                        "msg-problema-realizar-acao"
                    );
                })
                .finally((_) => {
                    this.isLoading = false;

                    /*  Depois que tudo estiver carregado, caso necessário, pega o que tem depois
                        do # na URL ($route.hash) para ver se coincide com o nome de uma aba para
                        poder trocar pra aquela aba.

                        Isso faz funcionar a URL direcionar a aba.
                        Ex: propriedade/uuid#talhoes irá abrir a abra de talhões automaticamente
                            após o carregamento. */
                    if (navigateToTab && this.$route.hash) {
                        let tab = this.$route.hash.replace("#", "");
                        this.navigateTab(tab);
                    }
                });
        },
        save() {
            this.isLoading = true;
            this.propriedade.cnpjcpf = this.propriedade.cnpjcpf.replaceAll(
                /[./-]/g,
                ""
            );
            let propriedadeTemp = Object.assign({}, this.propriedade);
            propriedadeTemp.unidadeMedida = this.isNull(
                propriedadeTemp.unidadeMedida
            )
                ? null
                : propriedadeTemp.unidadeMedida.id;
            // Caso não exista o campo situação na proriedade, criar com valor = 1 (ativo)
            if (
                propriedadeTemp.situacao == null ||
                propriedadeTemp.situacao == undefined
            ) {
                propriedadeTemp.situacao = 1;
            }
            propriedadeTemp = this.mapTosave(propriedadeTemp, "areas");

            if (this.validation.validate(propriedadeTemp, this.$refs)) {
                this.isSaving = true;

                this.service
                    .save(propriedadeTemp)
                    .then((r) => {
                        let msg = "msg-propriedade-salva";

                        if (this.id) {
                            msg = "msg-propriedade-edita";
                        }

                        this.$root.showMessage("success", msg);
                        this.saved = true;

                        if (this.$route.query.tela) {
                            this.redirectToPage();
                        }else{
                            this.$router.push({ name: "agro-propriedade-list" });
                        }
                    })
                    .catch((e) => {
                        if (e.body && e.body.message) {
                            if (e.body.message == "msg-descricao-duplicada") {
                                this.$root.showMessage("error", e.body.message);
                            } else {
                                this.$root.showMessage(
                                    "error",
                                    "msg-problema-realizar-acao"
                                );
                            }
                        } else {
                            this.$root.showMessage(
                                "error",
                                "msg-problema-realizar-acao"
                            );
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                        this.isSavingTalhao = false;
                        this.saved = true;
                        this.isLoading = false;
                    });
            }
        },
        saveTalhao(addToList = true) {
            let t = { ...this.mapTosave(this.talhao) };
            t.area = isNaN(Number(t.area)) ? 0 : Number(t.area);

            // Caso não exista o campo situação no talhão, criar com valor = 1 (ativo)
            if (t.situacao == null || t.situacao == undefined) {
                t.situacao = 1;
            }

            // @84514 - É necessário passar as áreas e a situação de edição para fazer as validações de descrições conflitantes
            if (this.validation.validateTalhao(t, this.$refs, this.propriedade.areas, this.currentEditTalhao)) {
                t.areadesc = undefined;
                let idxSalvo = this.propriedade.areas.findIndex(
                    (e) => e == this.talhao.areadesc
                );

                /*  Se na edição mudar a área do talhão, será necessário mudar o
                    objeto de área no array de áreas onde este talhão se encontra.
                    Caso contrário, só salva os dados.
                */
                if (this.currentEditTalhao > -1) {
                    if (idxSalvo !== this.currentEditArea) {
                        this.propriedade.areas[
                            this.currentEditArea
                        ].talhoes.splice(this.currentEditTalhao, 1);
                        this.propriedade.areas[idxSalvo].talhoes.push(t);
                        t.areadesc = {
                            descricao:
                                this.propriedade.areas[idxSalvo].descricao,
                            idarea: this.propriedade.areas[idxSalvo].idarea,
                        };
                    } else {
                        this.propriedade.areas[idxSalvo].talhoes[
                            this.currentEditTalhao
                        ] = t;
                        t.areadesc = {
                            descricao:
                                this.propriedade.areas[idxSalvo].descricao,
                            idarea: this.propriedade.areas[idxSalvo].idarea,
                        };
                    }
                    /*  Se a área não estiver selecionada, pode ser por que ela está oculta pelo MODULOPDA.
                    Mas como é obrigatório a área existir, este caso fará com que ela seja inserida na
                    primeira área. */

                    /* Mostra mensagem de confirmação avisando o usuário que é necessário salvar se não pode perder os dados de alteração. */
                    this.showWarningEdicao();
                } else if (!this.talhao.areadesc) {
                    this.propriedade.areas[0].talhoes.push(t);
                    t.areadesc = {
                        descricao: this.propriedade.areas[0].descricao,
                        idarea: this.propriedade.areas[0].idarea,
                    };
                } else {
                    this.propriedade.areas[idxSalvo].talhoes.push(t);
                    t.areadesc = {
                        descricao: this.propriedade.areas[idxSalvo].descricao,
                        idarea: this.propriedade.areas[idxSalvo].idarea,
                    };
                }

                if (addToList) {
                    if (
                        !this.newTalhoes.some((xd) => {
                            return xd.uuid == t.uuid;
                        })
                    ) {
                        this.newTalhoes.push(t);
                    } else {
                        let pos = this.newTalhoes.findIndex((x) => {
                            return x.uuid == t.uuid;
                        });
                        this.newTalhoes.splice(pos, 1);
                        this.newTalhoes.push(t);
                    }
                }

                this.cancelEditRow();
            }
        },
        updateTalhaoSort(sort, order) {
            this.column = sort;
            this.order = order;
            this.carregarTalhoes(this.currentPage);
        },
        redirectToPage() {
            if (this.$route.query.tela) {
                let tempAba = null;
                let tempTela = null;

                if (this.$route.query.tela == "cliente-propriedade") {
                    tempTela = this.isVenda ? "ven-cliente-dados-cadastrais-edit"
                    : "agro-cliente-dados-cadastrais-edit";
                    setTimeout(() => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: this.$route.query["id"] },
                            query: { 
                                dadoscadastrais: this.$route.query.dadoscadastrais,
                                politicacomercial: this.$route.query.politicacomercial,
                                analisecomercial: this.$route.query.analisecomercial 
                            },
                        });
                    }, 1000);
                } else {
                    // arrumar a volta para a tela de listagem de propriedades
                    tempTela = "agro-planosafra-edit";
                    tempAba = "planosafra-propriedade";
                    setTimeout(() => {
                            this.$router.push({
                                name: tempTela,
                            params: { id: this.$route.query["id"] },
                            query: { abaSelecionada: tempAba },
                        });
                    }, 1000);
                }
            } else {
                setTimeout(() => {
                    this.$router.push({
                        name: "agro-propriedade-list",
                    });
                }, 500);
            }
        },

        clearFields() {
            this.propriedade = {};
        },
        getModuloPropriedade() {
            if (this.$store.state.modulopda.disponivel && this.hasModulo("PROPRIEDADE")) {
                let modulo_propriedade = this.getModulo("PROPRIEDADE");

                /*  Isso cria o objeto para fazer com que os MODULOPDADETALHE sejam
                    possíveis de serem acessados diretamente.
                    Ex: this.detalhe.TALHAO_AREATALHAO.maxlength */
                modulo_propriedade.detalhe.forEach((d) => {
                    this.$set(this.detalhe, d.campo, d);
                });

                this.detalhe.length = modulo_propriedade.detalhe.length;
            }
        },
        getPosicao() {
            return {
                lat:
                    this.propriedade && this.propriedade.latitude
                        ? this.propriedade.latitude
                        : 0,
                lng:
                    this.propriedade && this.propriedade.longitude
                        ? this.propriedade.longitude
                        : 0,
            };
        },
        updatePosition(e) {
            this.propriedade.latitude = e.latLng.lat();
            this.propriedade.longitude = e.latLng.lng();
            this.infoWindow.open = false;
        },
        loadCurrentPosition() {
            /*  Verifica se a funcionalidade de geolocalização se encontra presente.
                Se o navegador não suportar, carrega a posição padrão (centro de Cascavel)
                para não quebrar o mapa. */
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(
                    (p) => {
                        this.zoomLevel = 14;
                        this.propriedade.latitude = p.coords.latitude;
                        this.propriedade.longitude = p.coords.longitude;
                    },
                    /*  Handler de erro, também carrega o valor padrão.
                    Causa mais comum é o usuário ter negado o prompt de pedir localização. */
                    (e) => {
                        console.warn(
                            `Não foi possível capturar localização: [${e.message}]`
                        );
                        this.propriedade.latitude = this.defaultPos.lat;
                        this.propriedade.longitude = this.defaultPos.lng;
                        this.center = this.defaultPos;
                        this.zoomLevel = 10;
                    }
                );
            } else {
                console.warn("Serviços de geolocalização não disponíveis.");
                this.propriedade.latitude = this.defaultPos.lat;
                this.propriedade.longitude = this.defaultPos.lng;
                this.center = this.defaultPos;
                this.zoomLevel = 10;
            }
        },
        /* Funções para carregar os itens nos combobox */
        carregarClientes(q) {
            this.clientesLoading = true;

            this.venClienteService
                .listAll(20, q)
                .then((r) => {
                    this.clientes = r.content;

                    if (this.$route.query.tela && this.$route.query["id"]) {
                        // Verifica se veio da tabela CLIENTE
                        if (this.$route.query.tela == "cliente-propriedade") {
                            this.setCliente(this.$route.query["id"]);
                        }
                    }
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de clientes. Termo: [${q}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.clientesLoading = false;
                });
        },
        setCliente(id) {
            // Utilizada apenas quando o cadastro veio da tela do Cliente.
            // Busca o cliente correto.
            this.venClienteService.loadClienteReduced(id).then((r) => {
                this.propriedade.cliente = r.content;
                this.fixedClient = true;
            });
        },
        carregarUnidades(q) {
            this.unidadesLoading = true;

            this.unidadeAreaService
                .findAllCombo(q ? q : "")
                .then((r) => {
                    this.unidades = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de unidades de medida de área. Termo: [${q}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.unidadesLoading = false;
                });
        },
        carregarTipos(q) {
            this.tiposCadastroTalhaoLoading = true;

            this.tipoService
                .findAllCombo(q ? q : "")
                .then((r) => {
                    this.tiposCadastroTalhao = r.content.map((e) => {
                        return {
                            idtipocadastrotalhao:
                                e.id || e.idtipocadastrotalhao,
                            descricao: e.descricao,
                        };
                    });
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de tipos de cadastro de talhão. Termo: [${q}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.tiposCadastroTalhaoLoading = false;
                });
        },
        carregarAreas(q = "") {
            let a = this.propriedade.areas || [];

            this.filteredAreas = a.filter((e) =>
                e.descricao.toLocaleLowerCase().includes(q.toLocaleLowerCase())
            );
        },
        carregarTalhoes(page = 1) {
            this.isLoadingTalhoes = true;
            this.currentPage = page;

            if (this.isNull(this.situacao)) {
                this.situacao = { label: "todos", id: 2 };
            }

            this.talhaoService
                .findAll(
                    this.propriedade.uuid,
                    this.column,
                    this.order,
                    this.currentPage - 1,
                    this.perPage,
                    this.situacao.id,
                    this.queryFilter
                )
                .then((r) => {
                    this.propriedade.areas.forEach((ar) => {
                        let talhoesTemp = [];

                        r.content.forEach((tl, ind) => {
                            if (
                                ar.idarea == tl.areadesc.idarea &&
                                this.newTalhoes.findIndex((x) => {
                                    return x.uuid == tl.uuid;
                                }) == -1
                            ) {
                                talhoesTemp.push(tl);
                                // r.content = r.content.splice(ind, 1);
                            }
                        });

                        if (this.newTalhoes.length > 0) {
                            this.newTalhoes.forEach((e) => {
                                if (ar.idarea == e.areadesc.idarea) {
                                    talhoesTemp.push(e);
                                }
                            });
                        }

                        ar.talhoes = talhoesTemp;
                    });
                })
                .catch((e) => {
                    console.error("Erro ao carregar talhões.", e);
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                })
                .finally((_) => {
                    this.isLoadingTalhoes = false;
                });
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value.replace(/[\.\-]/g, ""));
            this.currentPage = 1;
            this.carregarTalhoes(1);
        },
        updateSituacao(situacao) {
            if (!this.isNull(situacao)) {
                this.situacao = situacao;
            }
            this.carregarTalhoes();
        },
        /* Latitude e longitude a partir de um endereço pelo geocode do google */
        geocodeAddress(addr) {
            let a = { address: addr };

            if (!addr) {
                this.$root.showMessage("error", "msg-no-address-geocoder");
            } else if (
                this.geocoder &&
                typeof this.geocoder.geocode == "function"
            ) {
                this.geocoderLoading = true;

                this.geocoder.geocode(a, (resp, status) => {
                    if (status == "OK") {
                        let latlong = resp[0].geometry.location;

                        this.propriedade.latitude = latlong.lat();
                        this.propriedade.longitude = latlong.lng();
                        this.center.lat = latlong.lat();
                        this.center.lng = latlong.lng();

                        this.zoomLevel = 14;
                    } else {
                        if (status == "OVER_QUERY_LIMIT") {
                            console.error(
                                "[GEOCODER] O limite de requisições do Google API foi atingido!"
                            );
                        } else {
                            console.error(
                                `[GEOCODER] Erro ao requisitar Google Maps API: ${status}.`
                            );
                        }

                        this.$root.showMessage("alert", "msg-error-geocoder");
                    }

                    this.geocoderLoading = false;
                });
            } else {
                this.$root.showMessage("error", "msg-unavailable-geocoder");
            }
        },
        /* Métodos que vão mostrar o diálogo de confirmação antes de chamar a função em si. */
        promptForDelete(row) {
            this.delete = row;

            this.$root.confirm({
                message: this.$t("msg-confirmacao-desativacao-n", 
                    { n: row.descricao }
                ),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: (_) => {
                    this.delete = null;
                },
            });
        },
        promptForCompletion(row) {
            this.delete = row;

            this.$root.confirm({
                message: this.$t("msg-confirmacao-reativacao-n", { n: row.descricao }),
                onConfirm: this.updateSituacaoRegistro,
                onCancel: (_) => {
                    this.delete = null;
                },
            });
        },
        updateSituacaoRegistro() {
            this.delete.situacao = this.delete.situacao == 0 ? 1 : 0;
            let t = { ...this.mapTosave(this.delete) };

            if (
                !this.newTalhoes.some((xd) => {
                    return xd.uuid == t.uuid;
                })
            ) {
                this.newTalhoes.push(t);
            } else {
                let pos = this.newTalhoes.findIndex((x) => {
                    return x.uuid == t.uuid;
                });
                this.newTalhoes.splice(pos, 1);
                this.newTalhoes.push(t);
            }

            this.delete = {};
            this.showWarningEdicao();
        },
        showWarningEdicao() {
            this.$root.alert({
                message: this.$t("msg-aviso-salvamento-talhao"),
                onConfirm: (_) => {},
            });
        },
        editRow(row, indexArea, indexTalhao) {
            this.currentEditArea = indexArea;
            this.currentEditTalhao = indexTalhao;

            this.talhao = { ...row };
            this.talhao.tipocadastrotalhao = {
                idtipocadastrotalhao:
                    row.tipocadastrotalhao.idtipocadastrotalhao,
                descricao: row.tipocadastrotalhao.descricao,
            };
            this.talhao.areadesc = this.propriedade.areas[indexArea];
        },
        cancelEditRow() {
            this.talhao = {};
            this.currentEditArea = -1;
            this.currentEditTalhao = -1;
            this.$refs.areaInput.focusedOut = false;
            this.$refs.descricaoInput.focusedOut = false;
        },
        checkInvalid(campo, input) {
            let obrigainclusao;
            if (this.detalhe[campo]) {
                obrigainclusao = !!this.detalhe[campo].obrigainclusao;
            } else {
                /* Se não existir MODULOPDADETALHE, fazer verificação manual */
                switch (campo) {
                    case "NOME":
                    case "ENDERECO":
                        obrigainclusao = true;
                        break;
                    default:
                        obrigainclusao = false;
                        break;
                }
            }
            if (obrigainclusao) {
                if (typeof input == "string") {
                    return !input.trim();
                } else {
                    return !input;
                }
            } else {
                return false;
            }
        },
        validateCNPJInner() {
            let input = this.propriedade.cnpjcpf;
            if (!input) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = "msg-campo-obrigatorio";
            } else if (input && !(this.validateCnpj(input) || this.validateCPF(input))) {
                this.invalidCNPJ = true;
                this.invalidCNPJMsg = "msg-campo-invalido";
            } else {
                this.invalidCNPJ = false;
            }
            this.invalidCNPJ =
                this.checkInvalid("CNPJCPF", input) || this.invalidCNPJ;
        },
        editArea() {
            this.openModalArea = true;
            this.titulo = this.talhao.areadesc.descricao;

            /* JSON.parse(JSON.Stringify) para clonar o objeto sem que haja ligação com o antigo. */
            this.area = JSON.parse(JSON.stringify(this.talhao.areadesc));

            this.areaEditIdx = this.propriedade.areas.findIndex(
                (e) => e == this.talhao.areadesc
            );
        },
        newArea() {
            this.openModalArea = true;
            this.area = {
                descricao: "",
                talhoes: [],
            };
        },
        closeArea() {
            this.openModalArea = false;
            this.area = {};
            this.areaEditIdx = -1;
        },
        saveArea() {
            this.area = this.mapTosave(this.area);

            let existingIdx = this.propriedade.areas.findIndex(
                (e) => e.descricao == this.area.descricao
            );
            let exists = existingIdx > -1 && existingIdx != this.areaEditIdx;

            if (exists) {
                this.$root.showMessage("error", "msg-area-existente");
                return;
            } else if (this.areaEditIdx > -1) {
                this.propriedade.areas[this.areaEditIdx].descricao =
                    this.area.descricao;
            } else {
                this.propriedade.areas.push(this.area);
            }

            this.closeArea();
            this.carregarAreas("");
        },
        getAreaTotal(areas) {
            /**
             *  O que está acontecendo:
             *  Está indo dentro de cada área somar todos os talhões para ter
             *  a soma total de cada área (segundo reduce).
             *
             *  Com o valor da área cálculado, ele é somado ao total de todas
             *  as áreas (primeiro reduce, o de fora).
             *
             *  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
             */
            return areas
                ? areas.reduce((valorAtual, areaAtual) => {
                      return (
                          valorAtual +
                          areaAtual.talhoes.reduce(
                              (valorAtualTalhao, talhaoAtual) => {
                                  return (
                                      valorAtualTalhao + (talhaoAtual.area || 0)
                                  );
                              },
                              0
                          ) // Esse argumento depois da função do reduce é o valor inicial do somatório
                      );
                  }, 0)
                : 0;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "./mixins.scss";

.column {
    @include default-size-column;
}

#main {
    padding: 0 20px 20px 20px;
    height: auto;
    min-height: 100%;
    display: flex;
    flex-direction: column;

    .page {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        position: relative;

        .propriedade {
            flex-grow: 1;

            .nav.nav-tabs {
                margin-bottom: 0;
                margin-left: -20px;
                padding-left: 20px;
            }

            .fields {
                margin-bottom: 0;

                .column {
                    padding-top: 0.25rem;
                    padding-bottom: 0.25rem;
                }
            }

            .btn.in-form {
                padding: 0 10px;
                height: 36px;
                margin-top: 24px;
            }

            .map-area {
                display: flex;
                flex-grow: 1;
                width: 100%;

                .map-el {
                    min-height: 450px;
                    flex-grow: 1;
                }

                .info-window .info-window-message {
                    display: flex;
                    justify-content: flex-start;

                    .icon {
                        fill: $primary-color;
                        font-size: 14px;
                        padding-bottom: 5px;
                        margin-bottom: 5px;
                        border-bottom: 1px solid #d0cfcf;
                        height: 1.8rem;
                    }
                }
            }

            .drop {
                margin-top: 24px;
                .button {
                    height: 36px;
                }
            }

            .buttons.has-addons.drop {
                height: 44px;
            }

            .icon-help {
                height: 36px;
                width: 36px;
            }

            .m-edit {
                min-height: 100px;
            }

            .vss-grow {
                width: calc(100% - 5rem);
            }

            .situacao-select div {
                height: 40px;
            }

            .area-tables {
                padding-top: 20px;
            }
        }

        .title-modal {
            margin-right: 0px !important;
            word-break: break-word !important;
        }
    }
}
.hide-location {
    border: solid 2px #f9f9f9;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
</style>